import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';

const Style = styled.h1`
  &.CheckoutHeader {
    font-size: 28px;
    font-weight: 600;
    line-height: 20px;
    margin: 0 0 24px 0;
  }
`;

export const Header = () => {
  return (
    <Style className="CheckoutHeader">
      <FormattedMessage
        defaultMessage="Review and Book"
        description="Main heading for the checkout page where users review their booking details before completing purchase"
      />
    </Style>
  );
};
